
export default {
  props: {
    value: {
      required: true
    },
    element: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      model: undefined,

    }
  },

  watch: {
    model() {
      this.$emit('input', this.model);
    },
    value() {
      this.model = this.value;
    }
  },
  created() {
    this.model = this.value;
  }
};